import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { install as barItemExtensionInstall } from './bar';
import { install as dvLabelPositionExtensionInstall } from './dvLabelPosition';
import { install as dvItemBorderExtensionInstall } from './dvItemBorder';
import { install as stackBarAnimationExtensionInstall } from './stackBarAnimation';

export function install(registers: EChartsExtensionInstallRegisters) {
  barItemExtensionInstall(registers);
  dvLabelPositionExtensionInstall(registers);
  dvItemBorderExtensionInstall(registers);
  stackBarAnimationExtensionInstall(registers);
}
